export default [
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      `@/pages/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      `@/pages/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      `@/pages/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      `@/pages/Login.vue`
    )
  },
  {
    path: '/register',
    meta: {
      public: true,
    },
    name: 'register',
    component: () => import(
      `@/pages/Register.vue`
    )
  },
  {
    path: '/recover_password',
    meta: {
      public: true,
    },
    name: 'recover_password',
    component: () => import(
      `@/pages/RecoverPassword.vue`
    )
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/dashboard',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'Dashboard',
    component: () => import(
      `@/pages/Dashboard.vue`
    )
  },
  {
    path: '/ServiceOrderHistory',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'ServiceOrderHistory',
    component: () => import(
      `@/pages/service_orders/modify.vue`
    )
  },
  {
    path: '/ServiceOrder/new',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'NewServiceOrder',
    component: () => import(
      `@/pages/service_orders/new.vue`
    )
  },
  {
    path: '/Payment/deposit',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'Deposit',
    component: () => import(
      `@/pages/payment/deposit.vue`
    )
  },
  {
    path: '/Commission/history',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'CommissionHistory',
    component: () => import(
      `@/pages/commission/history.vue`
    )
  },
  {
    path: '/pages/commission/refinances',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/commission/refinances',
    component: () => import(
      `@/pages/commission/refinances.vue`
    )
  },
  {
    path: '/Art/new',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'NewArt',
    component: () => import(
      `@/pages/art/new.vue`
    )
  },
  {
    path: '/Order',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'Order',
    component: () => import(
      `@/pages/order/new.vue`
    )
  },
  {
    path: '/HistoryOrder',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'HistoryOrder',
    component: () => import(
      `@/pages/order/history.vue`
    )
  },
  {
    path: '/HistoryArt',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'HistoryArt',
    component: () => import(
      `@/pages/art/modify.vue`
    )
  },
  {
    path: '/pages/store/add',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/store/add',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/store/add.vue`
    )
  },
  {
    path: '/pages/store/modify',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/store/modify',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/store/modify.vue`
    )
  },
  {
    path: '/pages/api/add',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/api/add',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/api/add.vue`
    )
  },
  {
    path: '/pages/api/modify',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/api/modify',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/api/modify.vue`
    )
  },
  {
    path: '/pages/api/edit/:id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'EditApi',
    component: () => import(
      `@/pages/api/edit.vue`
    )
  },
  {
    path: '/pages/store/edit/:store_id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'EditSore',
    component: () => import(
      `@/pages/store/edit.vue`
    )
  },
  {
    path: '/pages/product_categories/modify/:store_id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/product_categories/modify',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/product_categories/modify.vue`
    )
  },
  {
    path: '/pages/basket_details/:id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/basket_details/show',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/basket_details/show.vue`
    )
  },
  {
    path: '/pages/product_categories/edit/:id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'EditCat',
    component: () => import(
      `@/pages/product_categories/edit.vue`
    )
  },
  {
    path: '/pages/payment_gateways/modify/:store_id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/payment_gateways/modify',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/payment_gateways/modify.vue`
    )
  },
  {
    path: '/pages/payment_gateways/edit/:id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'EditCat',
    component: () => import(
      `@/pages/payment_gateways/edit.vue`
    )
  },
  {
    path: '/pages/static_pages/modify/:store_id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/static_pages/modify',
    component: () => import(
      /* webpackChunkName: "static_pages" */
      /* webpackMode: "lazy-once" */
      `@/pages/static_pages/modify.vue`
    )
  },
  {
    path: '/pages/static_pages/edit/:store_id/:id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'EditPage',
    component: () => import(
      `@/pages/static_pages/edit.vue`
    )
  },
  {
    path: '/pages/static_pages/new/:store_id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'NewPage',
    component: () => import(
      `@/pages/static_pages/new.vue`
    )
  },
  {
    path: '/pages/template_setting/:store_id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'EditTemplate',
    component: () => import(
      `@/pages/template_setting/edit.vue`
    )
  },
  {
    path: '/pages/artworks/edit/:id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'EditArt',
    component: () => import(
      `@/pages/art/edit.vue`
    )
  },
  {
    path: '/pages/profile_setting/setting',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'ProfileSetting',
    component: () => import(
      `@/pages/profile_setting/setting.vue`
    )
  },
  {
    path: '/pages/users/list/:store_id',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'ListOfUsers',
    component: () => import(
      `@/pages/users/list.vue`
    )
  },
  {
    path: '/pages/extra_artworks/',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/extra_artworks/',
    component: () => import(
      `@/pages/extra_artworks/index.vue`
    )
  },
  {
    path: '/pages/invoices/',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/invoices/',
    component: () => import(
      `@/pages/invoices/list.vue`
    )
  },
  {
    path: '/pages/payments/',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/payments/',
    component: () => import(
      `@/pages/payment/list.vue`
    )
  },
  {
    path: '/pages/tickets/new',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/tickets/new',
    component: () => import(
      `@/pages/tickets/new.vue`
    )
  },
  {
    path: '/pages/manual_payment/add',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/manual_payment/add',
    component: () => import(
      `@/pages/manual_payment/add.vue`
    )
  },
  {
    path: '/pages/magic/add',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/magic/add',
    component: () => import(
      `@/pages/magic/add.vue`
    )
  },
  {
    path: '/pages/tickets/show/:tid',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'ShowTickets',
    component: () => import(
      `@/pages/tickets/show.vue`
    )
  },
  {
    path: '/pages/tickets/list',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: '/pages/tickets/list',
    component: () => import(
      `@/pages/tickets/list.vue`
    )
  },
  {
    path: '/pages/reports/list/:rpath',
    meta: {
      breadcrumb: false,
      public: false
    },
    name: 'Reports',
    component: () => import(
      `@/pages/reports/Report.vue`
    )
  },
];



// WEBPACK FOOTER //
// ./src/router/paths.js